import type { InMemoryCache } from '@apollo/client';
import { useApolloClient, useQuery } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import type React from 'react';

import type { Maybe } from '@xing-com/crate-common-graphql-types';

import { LOGGED_IN_CARDS_PER_PAGE } from '../../config';
import { XcpRecommendedCompaniesDocument } from '../../graphql/queries/recommended-companies.gql-types';

const useRecommendedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  const client = useApolloClient();
  // oxlint-disable-next-line typescript/consistent-type-assertions
  (client.cache as InMemoryCache).policies.addTypePolicies({
    Viewer: {
      fields: {
        companiesRecommendations: relayStylePagination(),
      },
    },
  });

  let variables = { first };
  const { error, fetchMore, ...rest } = useQuery(
    XcpRecommendedCompaniesDocument,
    {
      variables,
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
    }
  );

  const pagination = async (
    endCursor: Maybe<string>,
    deletedCompanies: number,
    setDeletedCompanies: React.Dispatch<React.SetStateAction<number>>
  ) => {
    variables = { first: first + deletedCompanies };

    await fetchMore({
      variables: {
        ...variables,
        after: endCursor,
      },
    });

    setDeletedCompanies(0);
  };

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useRecommendedCompanies };
